<template>
  <div v-hotkey="keymap">
    <contract-detail-history-list v-bind:reverse="reverse" type="Normal"></contract-detail-history-list>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueHotkey from 'v-hotkey'
  import {createNamespacedHelpers} from 'vuex'
  import ContractDetailHistoryList from "./ContractDetailHistoryList";
  import { confirmCode } from '@/constants/config'
  const moment = require('moment');

  const {mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting')
  Vue.use(VueHotkey)

  export default {
    name: "index",
    components:{
      ContractDetailHistoryList
    },
    data(){
      return {
        reverse: true
      };
    },
    async beforeMount() {
      await this.loadData(this.$route.params.id);
    },
    computed:{
      ...mapAccountingState(['status', 'contract', 'transactionsLoad']),
      keymap () {
        return {
          'alt+r': this.setReverse, // สลับรายละเอียดธุรกรรม
          'alt+d': this.fncDeleteTransactions, // ลบข้อมูลธุรกรรม
          'alt+g': this.fncReGenerateTransactions, // คำนวนธุรรกรรมจนถึงวันที่คำนวนดอกเบี้ยล่าสุด
          'alt+n': this.fncReGenerateTransactionsToNow, // คำนวนธุรรกรรมจนถึงวันที่ปัจจุบัน
          'alt+c': this.fncDeleteAllTransactions, // ลบข้อมูลทรานแซคชั่นทั้งหมด
        }
      },
    },
    methods:{
      ...mapAccountingActions(['getContract', 'toggleTransactionsLoad', 'getTransactionsByContractId', 'deleteTransactionsByContractIdAndTransactionDate', 'resetFeeDetails', 'reGenerateTransactions', 'deleteTransactions']),
      async loadData(id){
        await this.getContract({form: {id: id}});
        await this.getTransactionsByContractId({contractId: id});
      },
      setReverse () {
        this.reverse = !this.reverse
      },
      async fncDeleteTransactions () {
        const vm = this
        let transactionDate = prompt("กรุณากรอกข้อมูลวันที่ ที่ต้องการลบข้อมูลธุรกรรมทั้งหมดจนถึงปัจจุบัน", `${moment().format("DD-MM-YYYY")}`);
        const convTransactionDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(transactionDate)
        if (transactionDate !== null && transactionDate !== "" && convTransactionDate) {
          const {deleteTransactionsByContractIdAndTransactionDate } = vm;
          await deleteTransactionsByContractIdAndTransactionDate({
            contractId: vm.$route.params.id,
            transactionDate: convTransactionDate,
            extra: true
          })
        }
      },
      async fncReGenerateTransactions (){
        const vm = this
        const code = Math.floor(1000 + Math.random() * 9000);
        const inputCode = prompt("กรุณากรอกรหัสยืนยัน "+code+" เพื่ออัพเดทข้อมูลธุรกรรมทั้งหมด", "");
        if (code === Number(inputCode)) {
          vm.$vs.loading()
          const { reGenerateTransactions } = vm;
          await reGenerateTransactions({
            form: {
              contractId: vm.$route.params.id,
              updateToNow: false
            },
            vm: vm
          })
          setTimeout(() => {
            vm.$vs.loading.close()
          }, 150)
        } else {
          return false;
        }
      },
      async fncReGenerateTransactionsToNow (){
        const vm = this
        const code = Math.floor(1000 + Math.random() * 9000);
        const inputCode = prompt("กรุณากรอกรหัสยืนยัน "+code+" เพื่ออัพเดทข้อมูลธุรกรรมจนถึงวันที่ปัจจุบัน", "");
        if (code === Number(inputCode)) {
          vm.$vs.loading()
          const { reGenerateTransactions } = vm;
          await reGenerateTransactions({
            form: {
              contractId: vm.$route.params.id,
              updateToNow: true
            },
            vm: vm
          })
          setTimeout(() => {
            vm.$vs.loading.close()
          }, 150)
        } else {
          return false;
        }
      },
      async fncDeleteAllTransactions (){
        const vm = this
        const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการลบข้อมูลธุรกรรมทั้งหมด", "");
        if (confirmCode === inputCode) {
          const { deleteTransactions } = vm;
          await deleteTransactions({
            form: {
              id: vm.$route.params.id,
            },
            vm: vm
          })
        } else {
          return false;
        }
      },
    },
    watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
      '$route.params.id'(newVal, oldVal) {
        if(oldVal !== newVal){
          this.loadData(newVal);
        }
      }
    },
  }
</script>

<style scoped>

</style>
